import { useState } from "react";
import api from "../../../../api";
import { useToast } from "../../../../mantine/notifications/useToast";
import urls from "../../../../urls";
import { getMimeTypes } from "../../../../utils/getMimeTypes";
import { AnchorLink } from "../../../AnchorLink/AnchorLink";
import { DropzoneWithContent } from "../../../DropzoneWithContent/DropzoneWithContent";

function EnergyDataSteuersignale() {
  const [isSteuersignaleUploading, setIsSteuersignaleUploading] =
    useState(false);

  const { showErrorToast, showToast } = useToast();

  function uploadSteuersignale(file: File) {
    setIsSteuersignaleUploading(true);
    const formData = new FormData();
    formData["formDataObject"] = { file };
    api
      .post(
        urls.apiWithoutCamelization.ausfallarbeitSteuersignaleUpload(),
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      )
      .then(() =>
        showToast({
          type: "success",
          message: "Steuersignale erfolgreich hochgeladen"
        })
      )
      .catch((error) =>
        showErrorToast(
          error.response?.data?.detail ??
            "Fehler beim Hochladen der Steuersignale"
        )
      )
      .finally(() => setIsSteuersignaleUploading(false));
  }

  return (
    <DropzoneWithContent
      accept={getMimeTypes(["CSV", "EXCEL"])}
      loading={isSteuersignaleUploading}
      multiple={false}
      textContent={
        <>
          Klicken Sie hier oder ziehen Sie eine Datei in dieses Feld, um Dateien
          mit Steuersignalen hochzuladen.
          <br />
          <br />
          <AnchorLink
            href="https://node-energy.atlassian.net/wiki/x/UgAFqQ"
            onClick={(e) => e.stopPropagation()}
          >
            Zur Formatvorlage
          </AnchorLink>
        </>
      }
      onDrop={(files) => uploadSteuersignale(files[0])}
    />
  );
}

export { EnergyDataSteuersignale };
